module.exports = __webpack_public_path__ + "img/shopkeeper.d7cfa8df.png";